// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1J78o","textarea":"styles_textarea__3zVM8"};